import { gql } from 'graphql-request';

export const GET_TALENT_PROFILES = gql`
  query (
    $search: String
    $my_talents: Boolean
    $uncategorized: Boolean
    $division_ids: [ID!]
    $profile_types: [String!]
    $genders: [String!]
    $sag_statuses: [String!]
    $countries: [String!]
    $age_range_from: Int
    $age_range_to: Int
    $media_tags: [String!]
    $unions: [String!]
    $ethnicity: [String!]
    $sizes: [JSON!]
    $height: [String!]
    $weight: [String!]
    $hair: [String!]
    $eyes: [String!]
    $talent_ids: [String!]
  ) {
    profiles(
      search: $search
      uncategorized: $uncategorized
      divisionIds: $division_ids
      profileTypes: $profile_types
      genders: $genders
      sagStatuses: $sag_statuses
      countries: $countries
      ageRangeFrom: $age_range_from
      ageRangeTo: $age_range_to
      mediaTags: $media_tags
      unions: $unions
      ethnicity: $ethnicity
      sizes: $sizes
      height: $height
      weight: $weight
      hair: $hair
      eyes: $eyes
      myTalents: $my_talents
      talent_ids: $talent_ids
    ) {
      id
      profile_type
      status
      representation_type
      country
      note
      primary
      visibility
      talent {
        id
        email
        first_name
        last_name
        gender
        contact_no
        country
        country_code
        state_region
        adult_minor
        age_range_from
        age_range_to
        birth_date
        primary_type
        general
        statistics
        unions
        sag_status
      }
      division {
        id
        name
      }
      agency {
        name
        email
        company_type
        contact_first_name
        contact_last_name
        contact_number
        country
        state
        website
      }
      medium_attachments {
        primary
        medium_id
        mediumable_id
        mediumable_type
        tag_list
        medium {
          id
          file_type
          file_name
          file_size
          file_width
          file_height
          visible
          tag_list
        }
      }
      primary_medium_attachment {
        primary
        medium_id
        mediumable_id
        mediumable_type
        attachment
        modified_attachment
        medium {
          file_type
          file_name
          file_size
          file_width
          file_height
          visible
        }
      }
      images {
        id
        attachment
        modified_attachment
      }
      videos {
        id
        attachment
        modified_attachment
      }
      audios {
        id
        attachment
        modified_attachment
      }
      documents {
        id
        attachment
        modified_attachment
      }
    }
  }
`;

export const SEARCH_TALENT = gql`
  query (
    $first: Int
    $after: String
    $search: String
    $first_name: String
    $last_name: String
    $email: String
    $country: String
    $contact_no: String
  ) {
    talents_connection(
      first: $first
      after: $after
      search: $search
      firstName: $first_name
      lastName: $last_name
      email: $email
      country: $country
      contactNo: $contact_no
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        email
        first_name
        last_name
        country
        country_code
        picture
        medium_id
      }
    }
  }
`;
export const SPECIFIC_TALENT_EMAIL = gql`
  query ($id: ID, $email: String) {
    talent(id: $id, email: $email) {
      id
      email
      first_name
      stage_first_name
      middle_name
      stage_last_name
      last_name
      stage_name
      picture
      adult_minor
      user_types
    }
  }
`;

export const TALENT_PLAYLIST = gql`
  query ($parent_profile_id: ID!) {
    profile_playlist(parentProfileId: $parent_profile_id) {
      id
      type
      playlist_name
      agency {
        id
        name
      }
      division {
        name
        id
      }
      primary_medium_attachment {
        attachment
        modified_attachment
      }
      images {
        attachment
        modified_attachment
        id
      }
      videos {
        attachment
        modified_attachment
        id
      }
      audios {
        attachment
        modified_attachment
        id
      }
      social_media_accounts
    }
  }
`;

export const SPECIFIC_TALENT = gql`
  query ($id: ID!) {
    talent(id: $id) {
      id
      email
      first_name
      middle_name
      last_name
      stage_name
      stage_first_name
      stage_middle_name
      stage_last_name
      gender
      identifies_as
      contact_no
      country
      country_code
      state_region
      picture
      original_picture
      adult_minor
      age_range_to
      age_range_from
      birth_date
      primary_type
      sag_status
      sag_id
      unions
      resume
      statistics
      pets
      cars
      skills
      general
      biography
      other_phone_numbers
      other_email_addresses
      emergency_contact
      addresses {
        type
        location_name
        # address1
        # address2
        state_code
        country_code
        city_suburb
        zip_code
        primary
        address_type
        id
      }
      guardian {
        last_name
        first_name
        middle_name
        contact_no
        email
        country_code
      }
      notes
    }
  }
`;

export const SPECIFIC_TALENT_WORKSHEET_SIZE_CARD = gql`
  query ($id: ID!) {
    talent(id: $id) {
      id
      general
      email
      contact_no
      unions
      statistics
      stage_first_name
      stage_middle_name
      stage_last_name
      first_name
      middle_name
      last_name
      sag_status
      country
      state_region
      gender
      adult_minor
    }
  }
`;

export const SPECIFIC_TALENT_GENERAL_APPEARANCE = gql`
  query ($id: ID!) {
    talent(id: $id) {
      id
      gender
      identifies_as
      state_region
      adult_minor
      age_range_to
      age_range_from
      birth_date
      general
    }
  }
`;

export const SPECIFIC_TALENT_SIZE_CARD = gql`
  query ($id: ID!) {
    talent(id: $id) {
      id
      gender
      identifies_as
      state_region
      adult_minor
      age_range_to
      age_range_from
      birth_date
      general
      statistics
      country
      unions
    }
  }
`;

export const SPECIFIC_TALENT_PROFESSIONS = gql`
  query ($id: ID!) {
    talent(id: $id) {
      id
      other_profession_list
    }
  }
`;

export const SIZE_CARD_DATA = gql`
  query ($id: ID!) {
    talent(id: $id) {
      id
      statistics
    }
  }
`;

export const RESUME_DATA = gql`
  query ($id: ID!) {
    talent(id: $id) {
      id
      resume
    }
  }
`;

export const BIOGRAPHY_DATA = gql`
  query ($id: ID!) {
    talent(id: $id) {
      id
      biography
    }
  }
`;

export const SKILLS_DATA = gql`
  query ($id: ID!) {
    talent(id: $id) {
      id
      skills
    }
  }
`;

export const SOCIAL_DATA = gql`
  query ($id: ID!) {
    talent(id: $id) {
      id
      social_media_accounts
    }
  }
`;

export const TALENT_LIST_CARD = gql`
  query (
    $first: Int
    $after: String
    $my_talents: Boolean
    $search: String
    $uncategorized: Boolean
    $unviewed: Boolean
    $division_ids: [ID!]
    $profile_types: [String!]
    $genders: [String!]
    $sag_statuses: [String!]
    $countries: [String!]
    $age_range_from: Int
    $age_range_to: Int
    $actual_age_from: Int
    $actual_age_to: Int
    $media_tags: [String!]
    $unions: [String!]
    $ethnicity: [String!]
    $sizes: [JSON!]
    $height: [String!]
    $weight: [String!]
    $hair: [String!]
    $eyes: [String!]
    $age_class: [String!]
    $talent_ids: [ID!]
    $archived: Boolean
    $ghosted: Boolean
    $casting_role_id: ID
    $sort_by: String
    $search_tags: [String!]
  ) {
    profiles_connection(
      first: $first
      castingRoleId: $casting_role_id
      after: $after
      myTalents: $my_talents
      search: $search
      uncategorized: $uncategorized
      unviewed: $unviewed
      divisionIds: $division_ids
      profileTypes: $profile_types
      genders: $genders
      sagStatuses: $sag_statuses
      countries: $countries
      ageRangeFrom: $age_range_from
      ageRangeTo: $age_range_to
      actualAgeFrom: $actual_age_from
      actualAgeTo: $actual_age_to
      mediaTags: $media_tags
      unions: $unions
      ethnicity: $ethnicity
      sizes: $sizes
      height: $height
      weight: $weight
      hair: $hair
      eyes: $eyes
      ageClass: $age_class
      archived: $archived
      ghosted: $ghosted
      talentIds: $talent_ids
      sortBy: $sort_by
      searchTags: $search_tags
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        parent_profile_id
        id
        type
        completeness
        # profile_type
        # status
        # representation_type
        # country
        # note
        # primary
        # visibility
        # status
        # general
        # statistics
        search_tag_list
        division {
          id
          name
        }
        internal_note {
          comment
          created_at
          updated_at
          user {
            full_name
          }
        }
        permanent_note {
          comment
          created_at
          updated_at
          user {
            full_name
          }
        }
        search_tag_list
        # audition_flag {
        #     id
        #     flag_type
        #     comment
        # }
        my_talent
        talent {
          is_overscale
          id
          email
          first_name
          middle_name
          last_name
          gender
          contact_no
          country_code
          # country
          state_region
          # adult_minor
          age_range_from
          age_range_to
          social_media_accounts
          statistics
          stage_first_name
          stage_middle_name
          stage_last_name
          other_phone_numbers
          other_email_addresses
          # birth_date
          # primary_type
          # general
          unions
          sag_status
          ghosted
          picture
          profiles {
            id
          }
        }
        auditions {
          id
          is_overscale
          submission_note {
            comment
            created_at
          }
          primary_medium_attachment {
            id
            attachment
            modified_attachment
          }
          submitted_at
          submitted_by {
            full_name
          }
          casting_role {
            name
            id
          }
          created_at
        }
        agency {
          name
          id
          full_name
          #     email
          #     company_type
          #     contact_first_name
          #     contact_last_name
          #     contact_number
          #     country
          #     state
          #     website
        }
        # medium_attachments {
        #     primary
        #     medium_id
        #     mediumable_id
        #     mediumable_type
        #     tag_list
        #     medium {
        #         id
        #         file_type
        #         file_name
        #         file_size
        #         file_width
        #         file_height
        #         visible
        #         tag_list
        #     }
        # }
        # primary_medium_attachment {
        #     primary
        #     medium_id
        #     mediumable_id
        #     mediumable_type
        #     attachment
        #     modified_attachment
        #     medium {
        #         file_type
        #         file_name
        #         file_size
        #         file_width
        #         file_height
        #         visible
        #     }
        # }
        images {
          primary
          # id
          # attachment
          modified_attachment
          medium {
            file_height
            file_size
            id
            tag_list
          }
        }
        # videos {
        #     id
        #     attachment
        #     modified_attachment
        # }
        # audios {
        #     id
        #     attachment
        #     modified_attachment
        # }
        # documents {
        #     id
        #     attachment
        #     modified_attachment
        # }
      }
    }
  }
`;

export const QS_QUERIES = gql`
  query (
    $first: Int
    $after: String
    $my_talents: Boolean
    $search: String
    $uncategorized: Boolean
    $unviewed: Boolean
    $division_ids: [ID!]
    $profile_types: [String!]
    $genders: [String!]
    $sag_statuses: [String!]
    $countries: [String!]
    $age_range_from: Int
    $age_range_to: Int
    $age_range_type: String
    $actual_age_from: Int
    $actual_age_to: Int
    $media_tags: [String!]
    $unions: [String!]
    $ethnicity: [String!]
    $sizes: [JSON!]
    $height: [String!]
    $weight: [String!]
    $hair: [String!]
    $eyes: [String!]
    $city_suburbs: [String!]
    $age_class: [String!]
    $talent_ids: [ID!]
    $archived: Boolean
    $ghosted: Boolean
    $casting_role_id: ID
    $sort_by: String
    $search_tags: [String!]
    $project_id: ID
    $show_playlist_auditions: Boolean
    $skills: [JSON!]
    $conflict_tags: [String!]
    $show_with_conflict_tags: Boolean
  ) {
    profiles_connection(
      showPlaylistAuditions: $show_playlist_auditions
      projectId: $project_id
      first: $first
      castingRoleId: $casting_role_id
      after: $after
      myTalents: $my_talents
      search: $search
      uncategorized: $uncategorized
      unviewed: $unviewed
      divisionIds: $division_ids
      profileTypes: $profile_types
      genders: $genders
      sagStatuses: $sag_statuses
      countries: $countries
      ageRangeFrom: $age_range_from
      ageRangeTo: $age_range_to
      ageRangeType: $age_range_type
      actualAgeFrom: $actual_age_from
      actualAgeTo: $actual_age_to
      mediaTags: $media_tags
      unions: $unions
      ethnicity: $ethnicity
      sizes: $sizes
      height: $height
      weight: $weight
      hair: $hair
      eyes: $eyes
      ageClass: $age_class
      archived: $archived
      ghosted: $ghosted
      talentIds: $talent_ids
      sortBy: $sort_by
      searchTags: $search_tags
      skills: $skills
      conflictTags: $conflict_tags
      showWithConflictTags: $show_with_conflict_tags
      citySuburbs: $city_suburbs
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        parent_profile_id
        id
        type
        division {
          id
          name
        }
        internal_note {
          comment
          created_at
          updated_at
          user {
            full_name
          }
        }
        permanent_note {
          comment
          created_at
          updated_at
          user {
            full_name
          }
        }
        # search_tag_list
        # my_talent
        talent {
          gender
          birth_date
          adult_minor
          is_overscale
          id
          email
          first_name
          last_name
          # gender
          # contact_no
          # country_code
          age_range_from
          age_range_to
          # social_media_accounts
          statistics
          stage_name
          stage_first_name
          stage_last_name
          # other_phone_numbers
          unions
          # sag_status
          # ghosted
          # picture
          profiles {
            id
          }
          skills
        }
        auditions {
          id
          viewed
          is_overscale
          submission_note {
            comment
            created_at
          }

          primary_medium_attachment {
            id
            attachment
            modified_attachment
          }
          submitted_at
          submitted_by {
            full_name
          }
          casting_role {
            name
            id
          }
          created_at
        }
        agency {
          name
          id
          full_name
        }
        images {
          primary
          modified_attachment
          medium {
            file_height
            file_size
            id
            tag_list
          }
        }
      }
    }
  }
`;

export const TOTAL_TALENT_LIST = gql`
  query (
    $first: Int
    $after: String
    $my_talents: Boolean
    $search: String
    $uncategorized: Boolean
    $unviewed: Boolean
    $division_ids: [ID!]
    $profile_types: [String!]
    $genders: [String!]
    $sag_statuses: [String!]
    $countries: [String!]
    $age_range_from: Int
    $age_range_to: Int
    $media_tags: [String!]
    $unions: [String!]
    $ethnicity: [String!]
    $sizes: [JSON!]
    $height: [String!]
    $weight: [String!]
    $hair: [String!]
    $eyes: [String!]
    $age_class: [String!]
    $archived: Boolean
    $ghosted: Boolean
  ) {
    profiles_connection(
      first: $first
      after: $after
      myTalents: $my_talents
      search: $search
      uncategorized: $uncategorized
      unviewed: $unviewed
      divisionIds: $division_ids
      profileTypes: $profile_types
      genders: $genders
      sagStatuses: $sag_statuses
      countries: $countries
      ageRangeFrom: $age_range_from
      ageRangeTo: $age_range_to
      mediaTags: $media_tags
      unions: $unions
      ethnicity: $ethnicity
      sizes: $sizes
      height: $height
      weight: $weight
      hair: $hair
      eyes: $eyes
      ageClass: $age_class
      archived: $archived
      ghosted: $ghosted
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
`;

export const TALENT_LIST = gql`
  query (
    $first: Int
    $after: String
    $search: String
    $gender: String
    $age: Int
    $first_name: String
    $last_name: String
    $email: String
    $contact_no: String
    $country: String
  ) {
    talents_connection(
      first: $first
      after: $after
      search: $search
      gender: $gender
      age: $age
      firstName: $first_name
      lastName: $last_name
      email: $email
      contactNo: $contact_no
      country: $country
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        first_name
        last_name
        stage_first_name
        stage_last_name
      }
    }
  }
`;

export const MESSAGING_TALENT_RESPONSE = gql`
  query (
    $first: Int
    $after: String
    $search: String
    $gender: String
    $age: Int
    $first_name: String
    $last_name: String
    $email: String
    $contact_no: String
    $country: String
    $sort_by: String
    $talent_ids: [ID!]
    $my_talent: Boolean
  ) {
    talents_connection(
      first: $first
      after: $after
      search: $search
      gender: $gender
      age: $age
      firstName: $first_name
      lastName: $last_name
      email: $email
      contactNo: $contact_no
      country: $country
      sortBy: $sort_by
      talentIds: $talent_ids
      myTalent: $my_talent
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        email
        first_name
        last_name
        stage_first_name
        stage_last_name
        contact_no
        country_code
        other_phone_numbers
        other_email_addresses
        country
        guardian {
          id
          first_name
          last_name
          email
          contact_no
        }
      }
    }
  }
`;

export const NEW_TALENT_LIST_CARD = gql`
  query (
    $first: Int
    $after: String
    $my_talents: Boolean
    $search: String
    $uncategorized: Boolean
    $unviewed: Boolean
    $division_ids: [ID!]
    $profile_types: [String!]
    $genders: [String!]
    $sag_statuses: [String!]
    $countries: [String!]
    $age_range_from: Int
    $age_range_to: Int
    $age_range_type: String
    $actual_age_from: Int
    $actual_age_to: Int
    $media_tags: [String!]
    $unions: [String!]
    $ethnicity: [String!]
    $sizes: [JSON!]
    $height: [String!]
    $weight: [String!]
    $hair: [String!]
    $eyes: [String!]
    $age_class: [String!]
    $talent_ids: [ID!]
    $archived: Boolean
    $ghosted: Boolean
    $casting_role_id: ID
    $sort_by: String
    $search_tags: [String!]
    $with_tags: Boolean
    $city_suburbs: [String!]
    $skills: [JSON!]
  ) {
    profiles_connection(
      first: $first
      castingRoleId: $casting_role_id
      after: $after
      myTalents: $my_talents
      search: $search
      uncategorized: $uncategorized
      unviewed: $unviewed
      divisionIds: $division_ids
      profileTypes: $profile_types
      genders: $genders
      sagStatuses: $sag_statuses
      countries: $countries
      ageRangeFrom: $age_range_from
      ageRangeTo: $age_range_to
      ageRangeType: $age_range_type
      actualAgeFrom: $actual_age_from
      actualAgeTo: $actual_age_to
      mediaTags: $media_tags
      unions: $unions
      ethnicity: $ethnicity
      sizes: $sizes
      height: $height
      weight: $weight
      hair: $hair
      eyes: $eyes
      ageClass: $age_class
      archived: $archived
      ghosted: $ghosted
      talentIds: $talent_ids
      sortBy: $sort_by
      searchTags: $search_tags
      withTags: $with_tags
      citySuburbs: $city_suburbs
      skills: $skills
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        parent_profile_id
        id
        division {
          # id
          name
        }
        internal_note {
          comment
          created_at
          updated_at
          user {
            full_name
          }
        }
        permanent_note {
          comment
          created_at
          updated_at
          user {
            full_name
          }
        }
        search_tag_list
        my_talent
        talent {
          # is_overscale
          # id
          # first_name
          # last_name
          ghosted
          gender
          stage_first_name
          stage_last_name
          sag_status
          state_region
          age_range_from
          age_range_to
          statistics
          contact_no
          other_phone_numbers
          other_email_addresses
          email
          social_media_accounts
          unions
          birth_date
          adult_minor
          guardian {
            email
          }
        }
        agency {
          contact_first_name
          contact_last_name
        }
        representatives {
          user {
            first_name
            last_name
          }
        }
        division {
          id
          name
        }
        images {
          primary
          modified_attachment
          medium {
            file_height
            file_size
            id
            tag_list
          }
        }
      }
    }
  }
`;

export const TALENT_CALENDAR_EVENTS = gql`
  query (
    $first: Int
    $after: String
    $date_from: ISO8601Date
    $date_to: ISO8601Date
    $talent_ids: [ID!]
    $search: String
    $calendar_event_ids: [ID!]
    $timezone: String
  ) {
    calendar_events_connection(
      first: $first
      after: $after
      dateFrom: $date_from
      dateTo: $date_to
      talentIds: $talent_ids
      search: $search
      calendarEventIds: $calendar_event_ids
      timezone: $timezone
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        talent {
          id
        }
        title
        company_name
        role_name
        project_name
        location
        event_type
        notes
        start_datetime
        end_datetime
        timezone
        all_day
        # start_time
        # end_time
        repeats
        occurrences {
          happening_at
          ends_at
        }
        repeats_details
        creatable_id
        audition_schedule_id
      }
    }
  }
`;

export const CORE_CALENDAR_EVENTS = gql`
  query (
    $first: Int
    $after: String
    $date_from: ISO8601Date
    $date_to: ISO8601Date
    $talent_ids: [ID!]
    $search: String
    $calendar_event_ids: [ID!]
  ) {
    calendar_events_connection(
      first: $first
      after: $after
      dateFrom: $date_from
      dateTo: $date_to
      talentIds: $talent_ids
      search: $search
      calendarEventIds: $calendar_event_ids
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        talent {
          id
        }
        title
        company_name
        role_name
        project_name
        location
        event_type
        notes
        start_datetime
        end_datetime
        all_day
        occurrences {
          happening_at
          ends_at
        }
      }
    }
  }
`;

export const TALENT_SEARCH_CALENDAR_EVENTS = gql`
  query ($first: Int, $after: String, $talent_ids: [ID!], $search: String) {
    calendar_events_connection(first: $first, after: $after, talentIds: $talent_ids, search: $search) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        title
        event_type
        start_datetime
        end_datetime
        timezone
        all_day
        repeats
      }
    }
  }
`;
